import React from 'react';
import styled from 'styled-components';
import { navy, white } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const WIDTH = 0.6483790524;

const MapPinSVG = styled(Icon).attrs({ viewBox: '0 0 26 41' })`
    width: ${WIDTH}em;
`;

function MapPin({ color = navy, outlineColor = white, ...props }) {
    return (
        <MapPinSVG
            data-test="icon-map-pin"
            {...props}
        >
            <path
                d="M11.7,39.6L2.6,20.9C1.9,19.3.5,16.3.5,13,.5,6.1,6.1.5,13,.5s12.5,5.6,12.5,12.6c0,3.3-1.3,6.1-2,7.8l-9.2,18.7h-2.6zm1.3-32c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5,5.5-2.5,5.5-5.5S16,7.6,13,7.6 "
                fill={color}
                stroke={outlineColor}
                strokeMiterlimit="10"
                strokeWidth="0.9233"
            />
        </MapPinSVG>
    );
}

MapPin.WIDTH = WIDTH;

export {
    MapPin as default,
    MapPin,
};
